import React, { useEffect, useState } from "react";
import Button from "components/CustomButton";
import post_img from "assets/img/post_img.svg";
import { useHistory } from "react-router-dom";
import LazyLoadImage from "components/LazyLoadImage";

export default ({ post }) => {
  const history = useHistory();
  const [meetingId, setMeetingId] = useState();

  useEffect(() => {
    let meeting_id = post.data.url.split("/")[4];

    setMeetingId(meeting_id);
  },[post]);

  const goToRingCentralMeeting = () => {
    history.push(
      `/teams/${post?.team_id}/meeting?join=true&meetingId=${meetingId}`
    );

    history.push({
      pathname: `/teams/${post?.team_id}/meeting`,
      meetingData: {
        join: "true",
        meetingId: meetingId,
      },
    });
  };

  return (
    <>
      <div className="row va-center">
        <div className="col-lg-6 pl-0">
          <Button
            buttonClass="grad_btn join-btn"
            buttonStyle={{ width: "100%" }}
            onClick={goToRingCentralMeeting}
          >
            Join
          </Button>
        </div>
        <div className="col-lg-6 pr-0">
          <LazyLoadImage
            image={post_img}
            key="waterCoolerPost"
            alt="waterCoolerPost"
            imageClassName={"full_w waterCoolerPostImage"}
          />
        </div>
      </div>
    </>
  );
};
